import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import { SlideItemRenderer } from './SlideItemRenderer';
import properties from '../../constants/Properties';
import { setShortcutsTarget } from '../../actions/CurrentSlideActions';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import { AudioEditorTimeline } from '../audioEditor/menus/AudioEditorTimeline';
import { Ruler } from '../audioEditor/menus/Ruler';
import playController from '../utils/PlayController';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';

const SlidesListContent = React.createClass({
    getInitialState() {
        return {
            elements: [],
            order: this.getSlidesOrder(this.props.slides)
        };
    },
    getSlidesOrder(slides) {
        var order = '';
        var i;

        if (slides == undefined)
            return order;

        for (i=0; i<slides.length; i++) {
            if (slides[i])
                order = order + slides[i].uuid;
        }

        return order;
    },
    componentDidMount() {
        this.initElements();
    },
    componentWillReceiveProps(nextProps) {
        var newOrder = this.getSlidesOrder(nextProps.slides);
        var currentSlideTimeChanged = this.props.currentSlideTime != nextProps.currentSlideTime;

        if (!playController.isAudioEditorMode())
            currentSlideTimeChanged = false;

        if (this.state.order != newOrder || this.props.showAudioEditor != nextProps.showAudioEditor || currentSlideTimeChanged || this.props.accordionWidth != nextProps.accordionWidth || this.props.timelineWidth != nextProps.timelineWidth) {
            if (this.props.accordionWidth != nextProps.accordionWidth)
                this.recreateElements(false);
            else {
                if (this.props.timelineWidth != nextProps.timelineWidth)
                    this.recreateElements(true, true);
                else
                    this.recreateElements(true);
            }
        }
    },
    recreateElements(updateScroll = true, useOldScrollPosition = false) {
        setTimeout(this.refreshNewContent, 50, updateScroll, useOldScrollPosition);
    },
    refreshNewContent(updateScroll = true, useOldScrollPosition = false) {
        this.initElements(updateScroll, useOldScrollPosition);
    },
    initElements(updateScroll, useOldScrollPosition = false) {
        let elements = [];
        let items = this.props.slides;
        let i;
        let item;
        var slidesPosition = [];
        var totalWidth = 0;
        const currentIndex = storeManager.getState().currentSlide.currentSlideIndex;
        var time;

        for (i=0; i<items.length; i++) {
            item = items[i];

            if (currentIndex == i)
                time = storeManager.getState().currentSlide.model.time;
            else
                time = item.time;

            if (audioEditorUtils.refreshAllSlidesRenderers && this.props.showAudioEditor)
                elements.push(<SlideItemRenderer index={i} item={item} key={item.uuid} forceRefresh={Math.random()} showAudioEditor={this.props.showAudioEditor} zoomValue={this.props.zoomValue} time={time}/>);
            else
                elements.push(<SlideItemRenderer index={i} item={item} key={item.uuid} showAudioEditor={this.props.showAudioEditor} zoomValue={this.props.zoomValue} time={time}/>);

            slidesPosition.push(totalWidth);
            totalWidth = totalWidth + audioEditorUtils.getSlideWidth(time);
        }

        audioEditorUtils.refreshAllSlidesRenderers = false;

        if (playController.isAudioEditorAvailable() && this.props.showAudioEditor) {
            totalWidth = this.props.timelineWidth;
            audioEditorUtils.slidesPosition = slidesPosition;

            const holderStyle = {
                position: 'absolute',
                left: 0,
                top: 0,
                width: totalWidth
            };

            var holder = <div style={holderStyle} key={'audioEditor'}>
                            {elements}
                            <Ruler width={totalWidth} zoomValue={this.props.zoomValue} dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth}/>
                            <AudioEditorTimeline width={totalWidth} zoomValue={this.props.zoomValue} dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth}/>
                          </div>;

            elements = [holder];
        }

        this.setState({
            elements,
            order: this.getSlidesOrder(this.props.slides)
        });

        if (updateScroll) {
            playController.updateScrollPosition(300, useOldScrollPosition);
        }
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (e.target && e.target.className.indexOf('slideElement') != -1)
            this.props.dispatch(setShortcutsTarget(true));
        else
            this.props.dispatch(setShortcutsTarget(false));
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.elements != nextState.elements || this.props.accordionWidth != newProps.accordionWidth || this.props.windowWidth != newProps.windowWidth || this.props.slides != newProps.slides || this.props.dropIndex != newProps.dropIndex || this.props.needsRefresh != newProps.needsRefresh || this.props.showAudioEditor != newProps.showAudioEditor || this.props.zoomValue != newProps.zoomValue || this.props.currentSlideTime != newProps.currentSlideTime || this.props.timelineWidth != newProps.timelineWidth  || this.props.timelines != newProps.timelines)
            return true;
        else
            return false;
    },
    render() {
        if (this.state == undefined || this.state.elements == undefined)
            return (<div/>);

        const listWidth = this.props.windowWidth - this.props.accordionWidth - audioToolUtils.buttonsHolderWidth();

        const listStyle = {
            width: listWidth,
            height: this.props.listHeight,
            position: 'absolute',
            overflowY: 'hidden',
            overflowX: 'hidden',
            left: audioToolUtils.buttonsHolderWidth(),
            top: properties.SLIDE_VIEWER_TOP_LINE_HEIGHT,
            userDrag: 'none'
        };

        var paddingDrop = 0;

        if (this.props.dropIndex >= 0)
            paddingDrop = properties.SLIDE_PADDING_DROP;

        var listScrollWidth = this.state.elements.length * (properties.SLIDE_ITEM_WIDTH + properties.SLIDE_GAP) + paddingDrop;

        var componentProperties = {};
        componentProperties.paddingTop = properties.SLIDE_VIEWER_TOP_GAP;
        componentProperties.paddingLeft = 0;
        componentProperties.width = listWidth;
        componentProperties.scrollWidth = listScrollWidth;
        componentProperties.height = this.props.listHeight;
        componentProperties.top = 0;
        componentProperties.displayState = 'block';
        componentProperties.isHorizontal = true;
        componentProperties.id = 'slidesList';
        componentProperties.isAudioEditor = false;
        componentProperties.elements = this.state.elements;

        if (playController.isAudioEditorAvailable() && this.props.showAudioEditor)
            componentProperties.elementsLength = this.props.slides.length;

        if (this.props.showAudioEditor) {
            componentProperties.isAudioEditor = true;
            componentProperties.scrollWidth = this.props.timelineWidth;

            if (componentProperties.scrollWidth > componentProperties.width)
                componentProperties.scrollWidth = componentProperties.scrollWidth + 2;
        } else {
            if (platformDetection.isTouchableDevice())
                componentProperties.paddingTop = 0;
        }

        return (
            <div style={listStyle} onClick={this.onClick}>
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const dropIndex = state.slideViewer.dropIndex;
    const slides = state.production.slides ? state.production.slides : [];
    var accordionWidth = state.accordion.width;
    const needsRefresh = state.slideViewer.needsRefresh;
    const uuid = Math.random();
    var zoomValue = state.audioEditor.zoomValue;
    const currentSlideTime = (state.currentSlide && state.currentSlide.model) ? state.currentSlide.model.time : 0;
    var timelineWidth = state.audioEditor.timelineWidth;
    const timelines = state.audioEditor.timelines;

    if (zoomValue == undefined)
        zoomValue = 4;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    return {
        dropIndex,
        slides,
        accordionWidth,
        needsRefresh,
        uuid,
        zoomValue,
        currentSlideTime,
        timelineWidth,
        timelines
    };
}

export const SlidesList = connect(mapStateToProps)(SlidesListContent);



/** WEBPACK FOOTER **
 ** ./src/components/slideViewer/SlidesList.js
 **/